/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetRefundGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type GetRefundRequest = {
  /**
   * Identifier for the transfer.
   */
  transferID: string;
  accountID: string;
  /**
   * Identifier for the refund.
   */
  refundID: string;
};

export type GetRefundResponse = {
  headers: { [k: string]: Array<string> };
  result: components.CardAcquiringRefund;
};

/** @internal */
export const GetRefundGlobals$inboundSchema: z.ZodType<
  GetRefundGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type GetRefundGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const GetRefundGlobals$outboundSchema: z.ZodType<
  GetRefundGlobals$Outbound,
  z.ZodTypeDef,
  GetRefundGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function getRefundGlobalsToJSON(
  getRefundGlobals: GetRefundGlobals,
): string {
  return JSON.stringify(
    GetRefundGlobals$outboundSchema.parse(getRefundGlobals),
  );
}
export function getRefundGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<GetRefundGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetRefundGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetRefundGlobals' from JSON`,
  );
}

/** @internal */
export const GetRefundRequest$inboundSchema: z.ZodType<
  GetRefundRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  transferID: z.string(),
  accountID: z.string(),
  refundID: z.string(),
});
/** @internal */
export type GetRefundRequest$Outbound = {
  transferID: string;
  accountID: string;
  refundID: string;
};

/** @internal */
export const GetRefundRequest$outboundSchema: z.ZodType<
  GetRefundRequest$Outbound,
  z.ZodTypeDef,
  GetRefundRequest
> = z.object({
  transferID: z.string(),
  accountID: z.string(),
  refundID: z.string(),
});

export function getRefundRequestToJSON(
  getRefundRequest: GetRefundRequest,
): string {
  return JSON.stringify(
    GetRefundRequest$outboundSchema.parse(getRefundRequest),
  );
}
export function getRefundRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetRefundRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetRefundRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetRefundRequest' from JSON`,
  );
}

/** @internal */
export const GetRefundResponse$inboundSchema: z.ZodType<
  GetRefundResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: components.CardAcquiringRefund$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type GetRefundResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: components.CardAcquiringRefund$Outbound;
};

/** @internal */
export const GetRefundResponse$outboundSchema: z.ZodType<
  GetRefundResponse$Outbound,
  z.ZodTypeDef,
  GetRefundResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: components.CardAcquiringRefund$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function getRefundResponseToJSON(
  getRefundResponse: GetRefundResponse,
): string {
  return JSON.stringify(
    GetRefundResponse$outboundSchema.parse(getRefundResponse),
  );
}
export function getRefundResponseFromJSON(
  jsonString: string,
): SafeParseResult<GetRefundResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetRefundResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetRefundResponse' from JSON`,
  );
}
